import {SOPutRelationshipAttributePermissionRule} from '../../core/relationship-attribute-permission-rule/so-put-relationship-attribute-permission-rule';
import {RelationshipAttributePermissionRuleCore} from './relationship-attribute-permission-rule.core';
import {SOGetRelationshipAttributePermissionRule} from '../../core/relationship-attribute-permission-rule/so-get-relationship-attribute-permission-rule';
import {FormField, SelectionOption} from 'lionheartland';
import {putRelationshipAttributePermissionRuleFormFieldOptions} from './put-relationship-attribute-permission-rule-form-fields';
import {AdapterProtocol} from 'lionheartland';
import {BasePut} from 'lionheartland';
import {RelationshipAttributeCore} from '../relationship-attribute/relationship-attribute.core';
import {SOGetRelationshipAttribute} from '../../core/relationship-attribute/so-get-relationship-attribute';
import {RelationshipAttributePermissionCore} from '../relationship-attribute-permission/relationship-attribute-permission.core';
import {SOGetRelationshipAttributePermission} from '../../core/relationship-attribute-permission/so-get-relationship-attribute-permission';
import {ProjectCore} from '../project/project.core';
import {SOGetProject} from '../../core/project/so-get-project';
import {OrganizationCore} from '../organization/organization.core';
import {SOGetOrganization} from '../../core/organization/so-get-organization';

export class RAPutRelationshipAttributePermissionRule extends BasePut implements AdapterProtocol {
  formFieldOptions = Object.values(putRelationshipAttributePermissionRuleFormFieldOptions);

  RequestClass = SOPutRelationshipAttributePermissionRule

  constructor(
    public entityCore: RelationshipAttributePermissionRuleCore
  ) {
    super();
    if (putRelationshipAttributePermissionRuleFormFieldOptions.relationshipAttribute) {
      putRelationshipAttributePermissionRuleFormFieldOptions.relationshipAttribute.makeCore = true;
    }
    if (putRelationshipAttributePermissionRuleFormFieldOptions.relationshipAttributePermission) {
      putRelationshipAttributePermissionRuleFormFieldOptions.relationshipAttributePermission.makeCore = true;
    }
    if (putRelationshipAttributePermissionRuleFormFieldOptions.project) {
      putRelationshipAttributePermissionRuleFormFieldOptions.project.makeCore = true;
    }
  }

  onSet() {
    super.onSet()
  }

  prepareRequest() {
    this.request = new this.RequestClass(
      this.selectedEntity.uid,
      this.getFormValueFromIdentifier('name'),
      this.getFormValueFromIdentifier('description'),
      this.getFormValueFromIdentifier('whiteList'),
      this.getFormValueFromIdentifier('permissionType'),
      this.getFormValueFromIdentifier(
        'relationshipAttribute',
        SOGetRelationshipAttribute,
      ),
      this.getFormValueFromIdentifier(
        'relationshipAttributePermission',
        SOGetRelationshipAttributePermission,
      ),
      this.getFormValueFromIdentifier(
        'project',
        SOGetProject,
      ),
      this.getFormValueFromIdentifier(
        'organization',
        SOGetOrganization,
        true,
      ),
    )
  }


  onSelectionChange(field: FormField) {
    super.onSelectionChange(field)
  }

  fetchOptions(field: FormField) {
    super.fetchOptions(field)
  }

  getSelectionOption(field: FormField, entity): SelectionOption {
    return super.getSelectionOption(field, entity)
  }
}